import { useEffect } from 'react'
import { useTranslation } from 'react-i18next'

import { NOTIFICATION_TYPE } from '../../../../constants/common'
import { HTML_LINK_TARGET } from '../../../../constants/html'
import { stopPropagation } from '../../../../utils/events'
import { reconnectEmailAccount } from '../../Email.api'
import {
  EMAIL_CREATION_FORM_FIELD_NAME_FROM,
  EMAIL_CREATION_FORM_NEED_RECONNECT_ACCOUNT,
} from '../EmailCreationForm.constants'

export function useNeedReconnectNotification({
  accountId,
  handleCloseModal,
  needReconnect,
  removeNotification,
  setError,
  setNotification,
}) {
  const { t } = useTranslation()

  function handleReconnect(e) {
    stopPropagation(e)

    handleCloseModal()
    reconnectEmailAccount(accountId).then(response => {
      window.open(response?.data?.auth_url, HTML_LINK_TARGET.blank)
    })
  }

  useEffect(() => {
    if (needReconnect) {
      setError([EMAIL_CREATION_FORM_FIELD_NAME_FROM], true)
      setNotification({
        id: EMAIL_CREATION_FORM_NEED_RECONNECT_ACCOUNT,
        linkProps: {
          title: t('Form.ReconnectLinkKey'),
          onClick: handleReconnect,
        },
        text: t('Form.NeedReconnectErrorKey'),
        type: NOTIFICATION_TYPE.error,
      })
    } else {
      removeNotification(EMAIL_CREATION_FORM_NEED_RECONNECT_ACCOUNT)
      setError(EMAIL_CREATION_FORM_FIELD_NAME_FROM, null)
    }
  }, [accountId])
}
